// frontend/src/services/commands/CommandService.js
/**
 * Abstrakcyjna klasa bazowa dla wszystkich serwisów komend
 */
export class CommandService {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * Wykonaj komendę na urządzeniu
   * @param {string} deviceUuid - UUID urządzenia
   * @param {string} command - Nazwa komendy
   * @param {object} data - Dane komendy
   * @param {object} options - Opcje wykonania
   */
  async executeCommand(deviceUuid, command, data = {}, options = {}) {
    const { timeout = 30, async = false } = options;
    
    if (async) {
      return this.executeCommandAsync(deviceUuid, command, data, timeout);
    } else {
      return this.executeCommandSync(deviceUuid, command, data, timeout);
    }
  }

  /**
   * Wykonaj komendę asynchronicznie (przez Celery)
   */
  async executeCommandAsync(deviceUuid, command, data, timeout) {
    throw new Error('executeCommandAsync must be implemented by subclass');
  }

  /**
   * Wykonaj komendę synchronicznie (bezpośrednio przez WebSocket)
   */
  async executeCommandSync(deviceUuid, command, data, timeout) {
    throw new Error('executeCommandSync must be implemented by subclass');
  }

  /**
   * Sprawdź status zadania asynchronicznego
   */
  async checkTaskStatus(taskId) {
    return this.apiClient.get(`/tasks/${taskId}/status/`);
  }

  /**
   * Pobierz metadane komendy
   */
  async getCommandMetadata(command) {
    return this.apiClient.get(`/commands/metadata/${command}/`);
  }

  /**
   * Waliduj dane komendy
   */
  async validateCommand(command, data) {
    return this.apiClient.post('/commands/validate/', { command, data });
  }
}
